<template>
    <b-navbar toggleable type="dark" variant="dark" class="mb-4">
        <b-col cols="7" class="d-flex">
            <b-navbar-brand class="ml-auto" href="#" style="align-self: center !important; justify-self: center !important;">
                <img src="../../assets/logo.png" id="logo" alt="logo" class="w-100">
            </b-navbar-brand>
        </b-col>

      <div class="d-flex gap-sm">
      <span class="mostrar" style="color: white;">{{'Olá, ' +  usuarioLogado.nome}}</span>
      <b-navbar-toggle target="navbar-toggle-collapse">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>
      </div>
      <b-collapse id="navbar-toggle-collapse" is-nav>
        <b-navbar-nav class="ml-auto text-center">
          <router-link class="nav-link" to="/usuario/perfil">
                      Meus Dados
          </router-link>
          <b-nav-item href="#" @click="sair()">Sair</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </template>


<script>
export default {
	name: "NavBar",
	props: [],
	data() {
		return {
			usuarioLogado: JSON.parse(localStorage.getItem("usuario")),

		};
	},
	methods: {
		sair() {
			localStorage.clear();
			this.$router.push("/login");
		},
	},
};
</script>


  <style scoped>
  .navbar-brand{
    width: 20% !important ;
  }
  @media (max-width: 968px)
  {
  .mostrar{
      display: none !important;
  }
  .navbar-brand{
      width: 100% !important;
  }
  }
  </style>




// WEBPACK FOOTER //
// src/components/shared/NavBar.vue